
import api from './gatewayConfig'
import proxy from '../proxy.json'

const isLocal = api.apiMode === "local";
const isTest = api.apiMode === "test";

/** In test, show HTTP status, URL and backend payload in error dialogs (not in prod). */
export const verboseApiErrorsInTest = isTest;



export const featureFlags = {
  enableDashboard: true,
  enableNotifiche: true,
  enableRicariche: false,
  enableFatturazione: false,
  enableSaldoResiduo: false,
  enableMetodiPagamento: true,
  enableDashboardCharts: true,
  enableTicket: true,
  enableTicketPolling: true,
  enableNotificationPolling: true,
  enableSedeAziendaleValidationService: true,
};

const mockDataConfig = {
  account: false,
  pagamenti: false,
  click: false,
  catalog: false,
  products: false,
  ticket: false,
  notifiche: false,
};

export const CHART_IDS = {
  DAILY_TRAFFIC: "dailyTraffic",
  TOP_PRODUCTS_BY_CLICK: "topProductsByClick",
  TOP_PRODUCTS_BY_VIEW: "topProductsByView",
  TOP_CATEGORIES_BY_SEARCH: "topCategoriesBySearch",
  MONTHLY_REVENUE: "monthlyRevenue",
};

export const dashboardChartsEnabled = {
  [CHART_IDS.DAILY_TRAFFIC]: true,
  [CHART_IDS.TOP_PRODUCTS_BY_CLICK]: true,
  [CHART_IDS.TOP_PRODUCTS_BY_VIEW]: false,
  [CHART_IDS.TOP_CATEGORIES_BY_SEARCH]: true,
  [CHART_IDS.MONTHLY_REVENUE]: false,
};

export const dashboardChartsMock = {
  [CHART_IDS.DAILY_TRAFFIC]: false,
  [CHART_IDS.TOP_PRODUCTS_BY_CLICK]: false,
  [CHART_IDS.TOP_PRODUCTS_BY_VIEW]: false,
  [CHART_IDS.TOP_CATEGORIES_BY_SEARCH]: false,
  [CHART_IDS.MONTHLY_REVENUE]: isLocal,
};

export const VENDOR_STATS_CHART_LIMITS = {
  [CHART_IDS.TOP_PRODUCTS_BY_CLICK]: { grid: 5, list: 10 },
  [CHART_IDS.TOP_CATEGORIES_BY_SEARCH]: { grid: 7, list: 15 },
};


export function isDashboardChartEnabled(chartId) {
  return Boolean(featureFlags.enableDashboardCharts && dashboardChartsEnabled[chartId]);
}

export function isDashboardChartMockEnabled(chartId) {
  return Boolean(dashboardChartsMock[chartId]);
}

export function isMockEnabled(providerName) {
  return mockDataConfig[providerName] ?? false;
}

export const notificationPollingIntervalSec = 60;
export const ticketPollingIntervalSec = 60;
export const ticketMessagePollingIntervalSec = 30;

export const errorDialogDevelopmentMode = isLocal || verboseApiErrorsInTest;

export const locationiqApiKey = proxy.locationiq.apiKey;
